import { render, staticRenderFns } from "./ProductWhiteningProcess.vue?vue&type=template&id=319c07fd&scoped=true&"
import script from "./ProductWhiteningProcess.vue?vue&type=script&lang=js&"
export * from "./ProductWhiteningProcess.vue?vue&type=script&lang=js&"
import style0 from "./ProductWhiteningProcess.vue?vue&type=style&index=0&id=319c07fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c07fd",
  null
  
)

export default component.exports